module.exports = "/images/sidebar-2.jpg?32103624b1dd883d3d18dbcb1e0e8af6";